<template>
  <div class="pd">
    <div class="filters">
      <div class="chips">
        <button v-for="p in pilares" :key="p.v" class="chip" :class="{ on: fPilar === p.v }" type="button" @click="fPilar = p.v">{{ p.l }}</button>
      </div>
      <div class="chips">
        <button v-for="r in resps" :key="r.v" class="chip" :class="{ on: fResp === r.v }" type="button" @click="fResp = r.v">{{ r.l }}</button>
      </div>
    </div>
    <div class="mchips">
      <button v-for="m in 12" :key="m" class="mchip" :class="{ on: mes === m, done: monthDone(m) }" type="button" @click="mes = m">
        M{{ m }}<small>{{ monthLabel(m) }}</small>
      </button>
    </div>

    <div v-if="loading" class="muted">{{ $t('ARC_MGMT.LOADING') }}</div>
    <div v-else class="card">
      <table>
        <thead><tr><th>{{ $t('ARC_PANEL.DELIVERABLES.DELIVERY') }}</th><th>{{ $t('ARC_MGMT.PILLAR') }}</th><th>{{ $t('ARC_MGMT.RESPONSIBLE') }}</th><th>{{ $t('ARC_MGMT.INDICATORS.SITUATION') }}</th><th>{{ $t('ARC_PANEL.DELIVERABLES.DUE') }}</th><th /></tr></thead>
        <tbody>
          <tr v-for="d in list" :key="d.id">
            <td class="nm">{{ d.nome }} <span v-if="d.marco" class="marco">★ {{ d.nome_marco }}</span><span v-if="d.atrasada" class="late">{{ $t('ARC_MGMT.DELIVERABLES.LATE') }}</span></td>
            <td><span class="pl" :class="d.pilar">{{ d.pilar }}</span></td>
            <td class="who" :class="{ cli: d.responsavel === 'cliente' }">{{ d.responsavel === 'cliente' ? $t('ARC_PANEL.OVERVIEW.YOUR_TEAM') : 'Interativa' }}</td>
            <td><span class="pill" :class="stPill(d.status)">{{ $t('ARC_MGMT.STATUS.' + d.status) }}</span></td>
            <td class="sm">{{ d.prazo }}</td>
            <td class="acts"><button v-if="d.status === 'entregue' && canValidate" class="linkbtn" type="button" @click="validate(d)">{{ $t('ARC_PANEL.DELIVERABLES.VALIDATE') }}</button></td>
          </tr>
        </tbody>
      </table>
      <p class="footer">{{ $t('ARC_MGMT.DELIVERABLES.SUMMARY', { x: concluidas, y: total }) }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ArcAPI from 'dashboard/api/arc';

export default {
  props: { initialMonth: { type: Number, default: null } },
  data() {
    return {
      items: [], loading: true, total: 0, concluidas: 0, mes: this.initialMonth || 1,
      fPilar: 'all', fResp: 'all',
      pilares: [{ v: 'all', l: 'Todos' }, { v: 'A', l: 'Atendimento' }, { v: 'R', l: 'Receita' }, { v: 'C', l: 'Custo' }],
      resps: [{ v: 'all', l: 'Todos' }, { v: 'interativa', l: 'Interativa' }, { v: 'cliente', l: 'Sua equipe' }],
    };
  },
  computed: {
    ...mapGetters({ currentUser: 'getCurrentUser', access: 'arc/getAccess' }),
    list() {
      return this.items.filter(d => d.mes === this.mes &&
        (this.fPilar === 'all' || d.pilar === this.fPilar) &&
        (this.fResp === 'all' || d.responsavel === this.fResp));
    },
    canValidate() {
      return this.access.isConsultant || this.currentUser?.type === 'SuperAdmin' ||
        this.currentUser?.type_role === 'administrator' || this.currentUser?.role === 'administrator';
    },
  },
  mounted() { this.load(); },
  methods: {
    async load() {
      this.loading = true;
      try {
        const { data } = await ArcAPI.panelDeliverables();
        this.items = data.payload || []; this.total = data.total; this.concluidas = data.concluidas;
      } finally { this.loading = false; }
    },
    monthDone(m) { const it = this.items.filter(d => d.mes === m && d.status !== 'nao_aplicavel'); return it.length && it.every(d => ['entregue', 'validado'].includes(d.status)); },
    monthLabel() { return ''; },
    stPill(s) { return { entregue: 'ok', validado: 'ok', em_andamento: 'info', aguardando_cliente: 'warn' }[s] || 'mute'; },
    async validate(d) { await ArcAPI.validateDeliverable(d.id); this.load(); this.$emit('refresh'); },
  },
};
</script>

<style lang="scss" scoped>
.filters { display: flex; gap: var(--space-normal); flex-wrap: wrap; margin-bottom: var(--space-small); }
.chips { display: flex; gap: 6px; } .muted { color: var(--s-500); }
.chip { border: 1px solid var(--s-200); background: var(--white); border-radius: 20px; padding: 5px 11px; font-size: var(--font-size-small); font-weight: var(--font-weight-medium); color: var(--s-500); cursor: pointer; &.on { background: var(--s-900); border-color: var(--s-900); color: var(--white); } }
.mchips { display: flex; gap: 4px; overflow-x: auto; padding-bottom: 2px; margin-bottom: var(--space-normal); }
.mchip { border: 1px solid var(--s-200); background: var(--white); border-radius: 8px; min-width: 44px; padding: 5px 6px; font-size: 11.5px; font-weight: var(--font-weight-bold); color: var(--s-500); text-align: center; cursor: pointer; &.done { color: var(--g-700); } &.on { border-color: var(--w-500); background: var(--w-50); color: var(--w-700); } }
.card { background: var(--white); border: 1px solid var(--s-100); border-radius: 12px; padding: var(--space-normal); }
table { width: 100%; border-collapse: collapse; }
th { text-align: left; font-size: 10.5px; text-transform: uppercase; letter-spacing: .5px; color: var(--s-400); padding: 8px 10px; border-bottom: 1px solid var(--s-100); }
td { padding: 10px; border-bottom: 1px solid var(--s-75); font-size: var(--font-size-small); color: var(--s-900); vertical-align: middle; }
tr:last-child td { border-bottom: 0; }
.nm { font-weight: var(--font-weight-medium); } .marco { color: var(--y-700); font-size: var(--font-size-mini); margin-left: 6px; } .late { color: var(--r-500); font-size: var(--font-size-mini); margin-left: 6px; }
.who { color: var(--s-500); } .who.cli { color: var(--y-700); font-weight: var(--font-weight-medium); } .sm { color: var(--s-400); white-space: nowrap; }
.pl { display: inline-grid; place-items: center; width: 18px; height: 18px; border-radius: 5px; font-weight: 800; font-size: 10.5px; &.A { background: #E6F1FC; color: #1E88E5; } &.R { background: #E7F6EE; color: #1F9D63; } &.C { background: #EFECFF; color: #7B61FF; } }
.pill { display: inline-flex; border-radius: 20px; padding: 3px 10px; font-size: var(--font-size-mini); font-weight: var(--font-weight-medium); &.ok { background: var(--g-100); color: var(--g-800); } &.info { background: var(--w-50); color: var(--w-700); } &.warn { background: var(--y-100); color: var(--y-700); } &.mute { background: var(--s-75); color: var(--s-500); } }
.acts { text-align: right; } .linkbtn { border: 1px solid var(--w-200); background: var(--w-50); color: var(--w-700); font-size: var(--font-size-mini); font-weight: var(--font-weight-medium); border-radius: var(--border-radius-normal); padding: 4px 10px; cursor: pointer; }
.footer { color: var(--s-500); font-size: var(--font-size-small); margin-top: var(--space-normal); }
</style>
